module.exports = __webpack_public_path__ + "static/media/YB5M15_1.263caee4.jpg";